import {alpha, Box, Card, styled, Typography} from "@mui/material";

export const Container = styled(Card)(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(4),

    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
    },
}));

export const BlueContainer = styled(Container)(({theme}) => ({
    backgroundColor: theme.palette.primary.main,
}));

export const DataContainer = styled(Box)(({theme}) => ({
    marginLeft: theme.spacing(4),

    [theme.breakpoints.down('sm')]: {
        marginLeft: theme.spacing(2),
    },
}));

export const Title = styled(Typography)(({theme}) => ({
    color: alpha(theme.palette.primary.contrastText, 0.5),
    fontWeight: 100,
}));

export const Amount = styled(Typography)(({theme}) => ({
    marginTop: theme.spacing(-1),
    color: theme.palette.primary.contrastText,
    fontWeight: 900,

    [theme.breakpoints.down('sm')]: {
        fontSize: 50,
    },
}));

export const PreviousPeriodContainer = styled(Box)(({theme}) => ({
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    color: alpha(theme.palette.primary.contrastText, 0.9),
}));

export const PreviousPeriodIcon = styled(Box)(({theme}) => ({
    marginRight: theme.spacing(1),
    transform: 'rotate(90deg)',
    lineHeight: 0,
}));
